export const IMAGE_MIME_TYPE = 'image/png';
export const IMAGE_FILE_EXT = 'png';
export const FIREBASE_UPLOAD_MIME_TYPE = 'image/png';
